import * as React from "react"
import Button from "@mui/material/Button"
import Grid from "@mui/material/Grid"
import HelpIcon from "@mui/icons-material/Help"
import Tooltip from "@mui/material/Tooltip"
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ModeEditIcon from '@mui/icons-material/ModeEdit';

import { Box, Checkbox } from "@mui/material"
import RemoveShoppingCartIcon from '@mui/icons-material/RemoveShoppingCart';
import RentalNoteAccordion from "./RentalNoteAccordion"
import { RENTAL_STATUS_FRIENDLY_NAMES, RENTAL_CONTRACT_COLOR_MAP } from "../../Constants"
import { getDocumentation, moneyFormat } from "../../Utils"
import { useTheme } from "@emotion/react"
import ContractItemEditQuantityModal from "./modals/ContractItemEditQuantityModal"

export default function ContractItem({ item, refresh_function, setAdjustmentModal, cancelItem, closeEditQuantityModal, rentalItem }) {
    const theme = useTheme();
    const [quantityModalOpen, setQuantityModalOpen] = React.useState(false)

    return (
        <Box key={item.id} sx={{ border: 1, m: 1, p: 1 }}>
            <Grid container>
                <Grid xs>
                    <Grid container spacing={1} direction={"column"}>
                        <Grid xs>
                            <span style={{ fontSize: '1.17em' }}><b>{rentalItem?.unique_name}{rentalItem?.bulk_type ? ` (x${item.quantity})` : ''}</b></span>
                            {rentalItem?.bulk_type && item.status === "RESERVED" &&
                                <Button onClick={(e) => { setQuantityModalOpen(true) }}>
                                    <ModeEditIcon /> <Box sx={{ pl: 1 }}>Edit</Box>
                                </Button>
                            }
                        </Grid>
                        <Grid container>
                            <Grid item>
                                <Box sx={{ border: "1px solid grey", paddingLeft: "5px", paddingRight: "5px", backgroundColor: theme.palette[RENTAL_CONTRACT_COLOR_MAP[item.status] || 'primary'].main }}>
                                    <span><b>Status: {RENTAL_STATUS_FRIENDLY_NAMES[item.status]}</b></span>
                                </Box>
                            </Grid>
                            <Grid xs>
                            </Grid>
                        </Grid>
                        <Grid xs>
                            <Grid container spacing={6}>
                                <Grid item>
                                    {rentalItem?.image_path !== undefined && rentalItem?.image_path !== null && rentalItem?.image_path !== "" &&
                                        <Box component="img" alt={"Rental Item"} src={`/customerimages/client/${item.client_id}/rentalitems/${rentalItem.id}/${rentalItem.image_path}`} sx={{ maxHeight: '160px', maxWidth: '160px' }} />
                                    }
                                    {(rentalItem?.image_path === undefined || rentalItem?.image_path === null || rentalItem?.image_path === "") &&
                                        <Box component="img" alt={"Rental Item"} src={`/noimage.png`} sx={{ maxHeight: '160px', maxWidth: '160px' }} />
                                    }
                                </Grid>
                                <Grid xs>
                                    <Button onClick={() => getDocumentation(rentalItem, 'rentalitems')}><PictureAsPdfIcon />Documentation</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid xs>
                    <Grid container direction={"column"}>
                        <p style={{ marginLeft: 16 }}>Required:</p>
                        <Grid container sx={{ pl: '32px' }}>
                            <Grid xs>
                                <span>Rental Rate
                                    <Tooltip title={item.calculated_rate_visualization}>
                                        <HelpIcon sx={{ fontSize: 'inherit' }} />
                                    </Tooltip>
                                </span>
                            </Grid>
                            <Grid xs="auto">
                                <span>${moneyFormat(item.calculated_rate)}</span>
                            </Grid>
                        </Grid>
                        {item.cost_calculation.fees.filter((item) => item.optional !== true).map((fee) => {
                            const charge = item.rental_contract_item_charges.find(charge => charge.fee_id === fee.id)
                            return (<Grid container sx={{ pl: '32px', textDecoration: charge.refunded ? "line-through 2px" : "" }} key={fee.id}>
                                <Grid xs>
                                    {fee.fee_type === 'PERCENTAGE' && <span>{fee.name} ({fee.calculation}%)</span>}
                                    {fee.fee_type === 'FLAT_RATE' && <span>{fee.name}</span>}
                                    {fee.fee_type === 'FLAT_RATE_PER_ITEM' && <span>{`${fee.name} ($${moneyFormat(fee.calculation)}/item)`}</span>}
                                </Grid>
                                <Grid xs="auto">
                                    <span>${moneyFormat(charge.actual_cost ?? charge.estimated_cost)}</span>
                                </Grid>
                            </Grid>)
                        })}
                        {item.rental_contract_item_charges.filter(charge => charge.charge_type === 'ADJUSTMENT').map(charge =>
                            <Grid container sx={{ pl: '32px' }}>
                                <Grid xs>
                                    <span>Adjustment - {charge.description}</span>
                                </Grid>
                                <Grid xs="auto">
                                    <span>${moneyFormat(charge.actual_cost)}</span>
                                </Grid>
                            </Grid>
                        )}
                        <Grid container sx={{ pl: '32px' }}>
                            <Grid xs>
                                <span>Taxes ({item.cost_calculation.location_tax_rate}%)</span>
                            </Grid>
                            <Grid xs="auto">
                                <span>${moneyFormat(item.calculated_tax)}</span>
                            </Grid>
                        </Grid>
                        {item.cost_calculation.fees.filter((item) => item.optional === true).map.length > 0 && <p style={{ marginLeft: 16 }}>Optional:</p>}
                        {item.cost_calculation.fees.filter((item) => item.optional === true).map((fee) => {
                            return (<Grid container sx={{ pl: '32px' }} key={fee.id}>
                                <Grid xs="auto">
                                    <Checkbox
                                        sx={{ pt: 0, pb: 0 }}
                                        checked={item.rental_contract_item_charges.find(charge => charge.fee_id === fee.id)?.optional_selection || false}
                                        disabled
                                    />
                                </Grid>
                                <Grid xs>
                                    {fee.fee_type === 'PERCENTAGE' && <span>{fee.name} ({fee.calculation}%)</span>}
                                    {fee.fee_type === 'FLAT_RATE' && <span>{fee.name}</span>}
                                    {fee.fee_type === 'FLAT_RATE_PER_ITEM' && <span>{`${fee.name} ($${moneyFormat(fee.calculation)}/item)`}</span>}
                                </Grid>
                                <Grid xs="auto">
                                    <span>${moneyFormat(item.rental_contract_item_charges.find(charge => charge.fee_id === fee.id).actual_cost ?? item.rental_contract_item_charges.find(charge => charge.fee_id === fee.id).estimated_cost)}</span>
                                </Grid>
                            </Grid>)
                        })}
                        <hr></hr>
                        <Grid container columnSpacing={3} justifyContent="flex-end" sx={{ textAlign: 'right', fontWeight: 'bold' }}>
                            <Grid xs>
                                <Grid container direction="column">
                                    <Grid xs="auto">
                                        <span>Total:</span>
                                    </Grid>
                                    <Grid xs="auto">
                                        {item.cost_calculation.deposit.deposit_type === 'PERCENTAGE' && <span>Deposit ({item.cost_calculation.deposit.deposit_calculation}%{item.cost_calculation.deposit.deposit_include_fees ? " w/fees" : ""}):</span>}
                                        {item.cost_calculation.deposit.deposit_type === 'FLAT_RATE' && <span>Deposit:</span>}
                                        {item.cost_calculation.deposit.deposit_type === 'FLAT_RATE_PER_ITEM' && <span>{`Deposit ($${moneyFormat(item.cost_calculation.deposit.deposit_calculation)}/item):`}</span>}
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid xs="auto">
                                <Grid container direction="column">
                                    <Grid xs="auto">
                                        <span>${moneyFormat(item.calculated_posttax_total)}</span>
                                    </Grid>
                                    <Grid xs="auto">
                                        <span>${moneyFormat(item.calculated_deposit)}</span>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Grid container direction={"column"} alignItems={"flex-end"}>
                        {item.status === 'RESERVED' && <Grid xs="auto">
                            <Button onClick={() => cancelItem(item.id)} sx={{ color: 'red' }}>Cancel <RemoveShoppingCartIcon /></Button>
                        </Grid>}
                        <Grid xs="auto">
                            <Button sx={{ color: 'red' }} onClick={() => setAdjustmentModal({ open: true, rentalContractItem: item })}>Add Adjustment</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <RentalNoteAccordion
                refresh_function={refresh_function}
                rental_item_id={item.rental_item_id}
                rental_contract_item_id={item.id}
            />
            <ContractItemEditQuantityModal
                rentalContractItem={item}
                rentalItem={rentalItem}
                open={quantityModalOpen}
                closeModal={(result) => {
                    setQuantityModalOpen(false)
                    closeEditQuantityModal(result)
                }}
            />
        </Box>
    )
}